import { loadScript } from '@monoimin/utils/helpers';

import { isProductionEnv } from '../envUtils';

import type { Locales } from '@monoimin/sb-types';
import type { EventProperties } from '@segment/analytics-next';

export const forceTrackPage = ({
  action,
  properties = {},
}: {
  action?: string;
  locale?: Locales;
  properties?: EventProperties;
}) => {
  const isProduction = isProductionEnv();
  if (!isProduction) return;

  const pathname = window.location.pathname;
  window.rentaPageTracked = window.rentaPageTracked || {};

  if (window?.rentaPageTracked?.[pathname]) return;

  const trackPage = () => {
    try {
      window.renta.page(action, properties);
      window.rentaPageTracked![pathname] = true;
    } catch (error) {
      console.error('Error tracking page with renta:', error);
    }
  };

  if (window.renta) {
    trackPage();
  } else {
    loadScript({
      src: 'https://immigrantinvest.com/scripts/renta.js',
      id: 'renta-backup',
      onLoad: () => {
        if (!window.rentaPageTracked![pathname]) {
          trackPage();
        }
      },
    });
  }
};

export default forceTrackPage;
